import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withCookies } from 'react-cookie'
import { withStyles } from '@material-ui/core/styles';
import SyncIcon from '@material-ui/icons/Sync';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Backdrop from '@material-ui/core/Backdrop';
import Checkbox from '@material-ui/core/Checkbox';
import RolesApi from '../../libs/EdgeVMSCloudApi/Roles'
import CustomTable from '../custom/CustomTable';
import CustomTableHead from '../custom/CustomTableHead';
import CustomCircularProgress from '../custom/CustomCircularProgress';
import SearchBox from '../custom/SearchBox'
import { NavTableFooter } from '../table'
import ROWS_PER_PAGE_OPTIONS from '../../constants/navParams'
import { COOKIES } from '../../constants/cookieDefs'
import ConfirmAction from './confirmAction'

const useStyles = theme => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 240,
  },
  actionsCell: {
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  button: {
    minWidth: '125px',
  },
  backdrop: {
    position: "absolute",
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
});

class SelectRoleDialog extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isLoading: true,
      roleResponse: {},
      currentPage: '0',
      rowsPerPage: props.cookies.get(COOKIES.ROWS_PER_PAGE.name),
      searchString: '',
      showActionProgress: false,
      confirmDeleteActionOpen: false,
    }

    this.roleInAction = null
    this.abortController = new AbortController();
    this.signal = this.abortController.signal;
  }

  async componentDidMount () {
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  async handleRefresh () {
    const { currentPage, rowsPerPage, searchString } = this.state
    const { accountFilter, parentGroup } = this.props

    this.setState({isLoading: true})

    const response = await RolesApi.FetchRoles(this.signal, { currentPage, rowsPerPage, searchString, accountFilter }, parentGroup ? true : false)
    if (response.error && response.error.name === "AbortError") {
      return;
    }

    this.setState({
      roleResponse: response.ok ? response.body : {},
      isLoading: false,
    })
  };

  handleRequestSearch (event, value) {
    this.setState({ currentPage: '0', searchString: value.length ? value : "" }, () => this.handleRefresh())
    this.handleRefresh()
  };

  onPageChange(newValue) {
    this.setState({currentPage: newValue.toString()}, () => this.handleRefresh())
  };

  onRowsPerPageChange(newValue) {
    this.setState({rowsPerPage: newValue.toString()}, () => this.handleRefresh())
  };

  async onRowClick(isChecked, role) {
    let response = {}

    if (!isChecked) {
      if (this.props.assignRole) {
        this.setState({isLoading: true})
        response = await this.props.assignRole(this.signal, role.id)
        if (response.error && response.error.name === "AbortError") {
          return;
        }

        this.setState({isLoading: false})
        await this.handleRefresh()
      }
    } else {
      if (this.props.deassignRole) {
        this.onDeleteActionClick(role)
      }
    }
  }

  onDeleteActionClick (roleInAction) {
    if (roleInAction)
    {
      this.roleInAction = roleInAction
      this.setState({showActionProgress: false})
      this.setState({confirmDeleteActionOpen: true})
    }
  }

  async DeleteActionCallback (roleAnswer, toDelete) {
    if (roleAnswer && roleAnswer === 'ok' && toDelete && toDelete.id) {
      this.setState({showActionProgress: true})

      let response = await this.props.deassignRole(this.signal, toDelete.id)
      if (response.error && response.error.name === "AbortError") {
        return;
      }

      await this.handleRefresh()
    }
    this.setState({confirmDeleteActionOpen: false})
  };


  render () {
    const { classes, session, accountFilter, open, parentGroup } = this.props
    const { roleResponse, isLoading } = this.state
    const { currentPage, rowsPerPage, searchString } = this.state

    let { total, offset, roles } = roleResponse
    if (roles == null) {
      roles = []
    }

    if (total == null) {
      total = 0
    }

    if (offset == null) {
      offset = 0
    }

    if (!session.isLoggedIn){
      return null
    }

    return (
      <div>
        <Dialog
          fullWidth
          maxWidth='md'
          disableScrollLock
          open={open}
          onEnter={() => this.handleRefresh()}
          onClose={this.props.doneCallback}
        >
          <DialogTitle>Add Role</DialogTitle>

          <DialogContent>
            <Backdrop className={classes.backdrop} open={isLoading}>
              <CustomCircularProgress/>
            </Backdrop>

            <Box display="flex" justifyContent="flex-end">
              <SearchBox
                idKey={"role-dialog"}
                margin={"dense"}
                className={classes.formControl}
                disabled={isLoading}
                onSearch={this.handleRequestSearch.bind(this)}
                searchString={searchString}
              />
              <Tooltip title="Refresh">
                <span>
                  <IconButton id="refresh-icon" disabled={isLoading} onClick={this.handleRefresh.bind(this)}>
                    <SyncIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </Box>

            <CustomTable>
              <CustomTableHead>
                <TableRow selected={true}>
                  <TableCell padding="checkbox">Select</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Description</TableCell>
                </TableRow>
              </CustomTableHead>
              {roles.length ? (
                <TableBody>
                  {roles.map((role) => {
                    let isChecked = false

                    if (parentGroup && role.groups ) {
                      isChecked = role.groups.findIndex(groupId => groupId === parentGroup.id) > -1
                    } else {
                      return null
                    }

                    if (accountFilter && accountFilter.length) {
                      if (role.account_id.toString() !== accountFilter) {
                        return null
                      }
                    }

                    return (
                      <TableRow
                        hover
                        key={role.id}
                        role="checkbox"
                        tabIndex={-1}
                        onClick={this.onRowClick.bind(this, isChecked, role)}
                        selected={isChecked}
                      >
                        <TableCell padding="checkbox" align="center">
                          <Checkbox checked={isChecked} color='primary'/>
                        </TableCell>
                        <TableCell>{role.name}</TableCell>
                        <TableCell>{role.description}</TableCell>
                      </TableRow>
                  )})}
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell align='center' colSpan={3}>No Roles</TableCell>
                  </TableRow>
                </TableBody>
              )}

              <NavTableFooter
                noURLUpdate
                labelRowsPerPage='Roles per page'
                rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                count={total}
                rowsPerPage={parseInt(rowsPerPage, 10)}
                currentPage={total > 0 ? parseInt(currentPage, 10) : 0}
                onRowsPerPageChange={this.onRowsPerPageChange.bind(this)}
                onPageChange={this.onPageChange.bind(this)}
              />
            </CustomTable>
          </DialogContent>
          <DialogActions>
            <Button
              id="done-button"
              className={classes.button}
              variant="outlined"
              color="primary"
              onClick={this.props.doneCallback}
            >
              Done
            </Button>
          </DialogActions>
        </Dialog>

        <ConfirmAction
          title="Remove Role From Group ?"
          open={this.state.confirmDeleteActionOpen === true}
          showProgress={this.state.showActionProgress}
          progressMsg="Processing request to remove role from group..."
          actionCallback={this.DeleteActionCallback.bind(this)}
          callbackContext={this.roleInAction}
        >
          {`Are you sure you want to remove ${this.roleInAction ? "\"" + this.roleInAction.name + "\"" : "this"} role from ${parentGroup ? "\"" + parentGroup.name + "\"" : "this"} group ?`}
        </ConfirmAction>

      </div>
    )
  }
}

SelectRoleDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  session: PropTypes.object.isRequired,
  parentGroup: PropTypes.object,
  accountFilter: PropTypes.string,
  assignRole: PropTypes.func,
  deassignRole: PropTypes.func,
  doneCallback: PropTypes.func,
  showActionProgress: PropTypes.bool,
};

export default withCookies(withStyles(useStyles)(SelectRoleDialog))
